import React from "react";
import { Modal } from "react-bootstrap";
import { selectLoader } from "../utils/Helpers";

const AttentionModal = ({ show, onHide, handleAction,confirmationText, loading ,closeText}) => {
  return (
    <div>
      <Modal
        show={show}
        onHide={onHide}
        dialogClassName=""
        centered
        className="deletModal "
      >
        {/* <Modal.Header closeButton={true}>
        </Modal.Header> */}
        <Modal.Body>
         {confirmationText}
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={handleAction}
            className="delet-btn"
            style={{ padding: !loading ? "" : "0" }}
          >
            Ok
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AttentionModal;